export function mapVideoIdTypeForGCTL(videoId: string) {
  // GCTL expects a number for 'videoId', but doesn't account for clipHash strings
  return { videoId: videoId as unknown as number };
}
